/**
 * api/executionAgents.js — elenco congelado de uma execução (SPEC A3 §6).
 *
 *   GET /executions/{id}/agents → ExecutionAgentOut[]
 *     { agent_name, node_label, status_catalogo, prompt_origem, prompt_version, prompt_hash,
 *       prompt_chars, tier, resolved_model, tool_profile, skills:[{name, tem_conteudo}],
 *       etapas[], origem_responsavel:{etapa: aprovado|proposto|papel_padrao},
 *       estimativa:[{etapa, tokens|null, custo_usd|null, motivo?}] }
 *   404 = execução fora do tenant (ou anterior ao snapshot) → [] .
 *
 * Arquivo próprio (e não em executions.js) para não exigir mudança nos mocks das telas
 * que já consomem '@/api/executions'.
 */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export const executionAgentsKey = (id) => ['executions', id, 'agents'];

export function useExecutionAgents(executionId) {
  const api = useApi();
  return useQuery({
    queryKey: executionAgentsKey(executionId),
    queryFn: async () => {
      try {
        const data = await api.get(`/executions/${executionId}/agents`);
        return Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
      } catch (err) {
        if (err?.status === 404) return [];
        throw err;
      }
    },
    enabled: Boolean(executionId),
    staleTime: 15_000,
  });
}
